function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 16.23c1.163 0 2.16-.414 2.988-1.242.828-.828 1.242-1.824 1.242-2.988V5.23c0-1.163-.414-2.159-1.242-2.987C14.159 1.415 13.163 1 12 1c-1.164 0-2.16.415-2.988 1.243-.829.828-1.243 1.824-1.243 2.988V12c0 1.164.414 2.16 1.243 2.988.828.828 1.824 1.242 2.988 1.242z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.364 9.713a.812.812 0 00-.595-.252.814.814 0 00-.595.252.813.813 0 00-.251.595V12c0 1.63-.58 3.025-1.739 4.184-1.159 1.16-2.554 1.739-4.184 1.739-1.63 0-3.026-.58-4.185-1.739C6.656 15.026 6.077 13.631 6.077 12v-1.692a.813.813 0 00-.251-.595.813.813 0 00-.595-.252.813.813 0 00-.595.252.813.813 0 00-.252.595V12c0 1.948.65 3.643 1.95 5.083 1.3 1.441 2.907 2.268 4.82 2.48v1.745H7.769a.813.813 0 00-.595.25.813.813 0 00-.251.596c0 .229.084.427.251.595A.814.814 0 007.77 23h8.461c.23 0 .428-.084.595-.251a.813.813 0 00.252-.595.812.812 0 00-.252-.595.812.812 0 00-.595-.252h-3.384v-1.745c1.913-.211 3.519-1.038 4.819-2.479 1.3-1.44 1.95-3.135 1.95-5.083v-1.692a.813.813 0 00-.251-.595z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.657 3.476l-3.629 3.526-4.01 3.895-1.202 1.168L3.549 22.04c-.457.444-1.199.444-1.656 0l-.55-.534a1.115 1.115 0 010-1.61L20.451 1.334a1.196 1.196 0 011.656 0l.55.534a1.115 1.115 0 010 1.61z",
  fill: "#000"
});

function SvgMicrophoneMuted(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgMicrophoneMuted;